// src/config/contentConfig.js
export const contentConfig = {
  projects: {
    // folders: ['proj1', 'proj2', 'proj3', 'proj4'], // 不再需要
    path: 'content/projects' // 基础路径，相对于 public 目录
  },
  experiences: {
    // folders: ['exp1', 'exp2', 'exp3', 'exp4', 'exp5'], // 不再需要
    path: 'content/experiences'
  },
  education: {
    // folders: ['edu1', 'edu2'], // 不再需要
    path: 'content/education'
  },
  personal: {
    // 个人信息通常是单个文件，所以保持不变
    path: 'content/personal/personal.md'
  }
};

// 缓存过期时间（毫秒）
export const CACHE_EXPIRY = 5 * 60 * 1000; // 5分钟